import React, { FC, HTMLAttributes } from 'react'
import cn from 'classnames'

export const ContentContainer: FC<HTMLAttributes<HTMLDivElement>> = ({ children, className }) => {
  return <div className={cn('mx-auto max-w-screen-xl', className)}>{children}</div>
}

export default ContentContainer
